import { Column } from "@tanstack/react-table"

import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
} from "../../DropdownMenu"
import { LE_TableInstance } from "../types"

export function SingleEnumFilter<T extends Record<string, any> = object>({
  col,
  filterValue,
  table,
}: {
  col: Column<T>
  filterValue?: string
  table: LE_TableInstance<T>
}) {
  const label = col.columnDef.meta?.textLabel ?? col.columnDef.header
  if (typeof label !== "string") {
    throw new Error(
      "column `header` must be a string, or `meta.textLabel` must be set.",
    )
  }

  let filterOptions: [string, string][] = []
  if (!col.columnDef.meta?.filterOptions) {
    if (table.options.manualFiltering) {
      throw new Error(`meta.filterOptions of column "${label}" must be defined`)
    } else {
      const keys = col.getFacetedUniqueValues().keys()
      filterOptions = Array.from(keys).map((v) => [v, v])
    }
  } else {
    filterOptions = Object.entries(col.columnDef.meta.filterOptions)
  }

  return (
    <>
      <DropdownMenuLabel>{label}</DropdownMenuLabel>
      <DropdownMenuSeparator />
      <div className="max-h-80 overflow-auto">
        <DropdownMenuRadioGroup value={filterValue}>
          {filterOptions.map(([value, label]) => (
            <DropdownMenuRadioItem
              key={value}
              value={value}
              onSelect={(event) => {
                event.preventDefault()
                col.setFilterValue(value)
              }}
            >
              {label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </div>
    </>
  )
}
